const item_template = `
<span class="date-column">{{#date_simple_UTC}}{{this.attributes.created_at}}{{/date_simple_UTC}}</span>
<span class="charge">{{this.attributes.amount_str}}</span>
<span class="event">{{this.attributes.item_type}}</span>
<span class="qty">{{this.attributes.count}}</span>
<span class="description">{{this.attributes.description}}</span>
{{#if details}}
<a class="show-details details" data-id="{{this.id}}">Details ({{details.length}})</a>
    <div class="details-list">
        <div class="line-item header" data-id="{{this.id}}">
            <span class="date-column">Date</span>
            <span class="device-id">Device ID</span>
            <span class="connections">Connections</span>
            <span class="data-sent">Data Sent</span>
            <span class="data-received">Data Received</span>
        </div>

        {{#each details}}
            <div class="line-item">
                <span class="date-column">{{#date_simple_UTC}}{{this.created_at}}{{/date_simple_UTC}}</span>
                <span class="device-id id-region">{{this.device_id}}</span>
                <span class="connections">{{this.cell_conn_count}}</span>
                <span class="data-sent">{{this.cell_num_sent}} messages ( {{this.cell_sent}} bytes )</span>
                <span class="data-received">{{this.cell_num_recv}} messages ( {{this.cell_recv}} bytes )</span>
            </div>
        {{/each}}
    </div>
{{else}}
    <span class="details">no details</span>
{{/if}}`;

function mbify(data) {
    const MB = 1024 * 1024;
    if ( !data || data === 0 ) return '--'; 
    if (data % MB === 0)  { 
        return '' + (data / MB) + ' MB'; 
    }
    return '' + data;
}

import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';

const LineItemView = Marionette.View.extend({
    className: 'line-item',
    tagName: 'div',
    ui: {
        show_details: '.show-details',
        close_details: '.show-details.open'
    },
    events: {
        'click @ui.show_details' : 'show_details',
        'click @ui.close_details' : 'close_details'
    },
    template: Handlebars.compile(item_template),
    templateContext: function() {
        let details = this.model.get('details');
        let amount = Number(this.model.get('amount'));
        let amount_str;
        let total_data = 0;
        let total_connections = this.model.get('count');
        if ( amount < 0 ) {
            amount_str = '$' + -amount.toFixed(2);
        } else {
            amount_str = '$' + amount.toFixed(2);
        }

        this.model.set('amount_str', amount_str);

        if ( this.model.get('bytes') ) {
            this.model.set('data_str', mbify(Number(this.model.get('bytes'))));
        }

        return {
            total_connections,
            total_data,
            amount_str,
            details,
            attributes: this.model.attributes
         };
    },
    show_details: function(e) {
        this.$el.addClass('active');
        this.ui.show_details.addClass('open');
    },
    close_details: function(e) {
        this.$el.removeClass('active');
        this.ui.show_details.removeClass('open');
    },
});

export default LineItemView;
